import { AnswerPathTreeNode } from '@zinnia/form-engine-sdk';

import { NodeIds } from '../../../../nodeIds';

export const lupus: AnswerPathTreeNode = {
  path: 'lupus',
  children: [{ path: 'details', nodeId: NodeIds.healthInsuredLupusDetails }],
};
